import React from 'react';
import { motion } from 'framer-motion';
import { FaRocket, FaGlobe } from 'react-icons/fa'; // optional icons

const MissionVision = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 via-white to-gray-100 py-20 md:py-28 overflow-hidden">
      {/* Animated blobs */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-red-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-rose-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-orange-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-extrabold">
            <span className="text-red-600">Our Mission &</span>{' '}
            <span className="text-gray-900">Vision</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-lg">
            Guiding principles that shape our journey and inspire innovation.
          </p>
        </motion.div>

        {/* Mission & Vision cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* Mission Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="group relative bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-white/50"
          >
            <div className="flex items-center gap-3 mb-6">
              <FaRocket className="text-3xl text-red-500" />
              <h3 className="text-2xl font-bold text-gray-800 group-hover:text-red-600 transition-colors">
                Our Mission
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">
              At <span className="font-semibold text-red-600">UB Creations</span>, our mission is to craft immersive digital experiences that entertain, educate, and inspire users worldwide.
              We are committed to delivering innovative, high-quality games and applications that push the boundaries of creativity and technology.
              Through collaboration, passion, and user-focused design, we strive to empower the next generation of creators and gamers alike.
            </p>
          </motion.div>

          {/* Vision Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="group relative bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-white/50"
          >
            <div className="flex items-center gap-3 mb-6">
              <FaGlobe className="text-3xl text-red-500" />
              <h3 className="text-2xl font-bold text-gray-800 group-hover:text-red-600 transition-colors">
                Our Vision
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">
              To become a global leader in interactive digital entertainment and software development, where creativity meets technology to shape the future of gaming and beyond.
              We envision a world where <span className="font-semibold text-red-600">UB Creations</span> solutions are a symbol of quality, innovation, and social impact fostering joy, connection, and opportunity for all.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Custom animations */}
      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </section>
  );
};

export default MissionVision;